<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
      <div class="border-div height-one">
        <!--<div class="d-flex chart-box-header margin-bottom-30 align-item-center floatinghead clearfix">
      <h2 class="mainhead mainhead-xs"><span class="text">Financial News</span></h2>
  </div>-->
        <div class="floatinghead clearfix margin-bottom-30" *ngIf="!hideStocInfo">
          <h2 class="mainhead mainhead-xs"><span class="text">Tenant Credit Info</span></h2>
          <div class="rightside clearfix">
            <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" placement="left" tooltip="Add Tickers" style="float:right" (click)="openAddTicker(AddTicker,'panlestyle')"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
          </div>
        </div>
        <div *ngIf="!tickersAvailable" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Tickers Available</p>
          </div>
        </div>
        <app-stock-info (tickerChanges)="tickerChanges($event)" [tickerSymbol]="tickerSymbol" [sellerId]="sellerId" [prevPage]="prevPage" [isFromDashboard]="hideStocInfo" *ngIf="!hideStocInfo" [SourcePage]="currentsourcepage"></app-stock-info>
        <div class="d-flex chart-box-header margin-bottom-30 margin-top-20 align-item-center">
          <h2 class="mainhead mainhead-xs"><span class="text" *ngIf="!hideStocInfo">Recent Headlines</span><span class="text" *ngIf="hideStocInfo && tickersAvailable">Market News</span></h2>
        </div>
        <div *ngIf="!tickersAvailable" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Tickers Available</p>
          </div>
        </div>

        <div class="row recent-stock-news-wrap" *ngIf="showNewsFeed && tickersAvailable">
          <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12" *ngFor="let item of newsList">
            <div class="recent-news-wrap d-flex">
              <div class="news-img">
                <a href="{{item.news_url}}" target="_blank"><img src="{{item.image_url}}" /></a>
              </div>
              <div class="news-contents">
                <h3><a href="{{item.news_url}}" target="_blank" class="blueone">{{item.title}}</a></h3>
                <span class="date">Updated: {{item.date | date :'dd MMM y h:mm a'}}</span>
                <p class="news-text">{{item.text.substring(0, 60)+'...'}}</p>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="hideStocInfo">
            <a *ngIf="generalNewsList.length > newsList.length" (click)="viewMore()" class="pull-right">View More..</a>
            <a *ngIf="newsList.length > 12" (click)="viewLess()" class="pull-left">View Less..</a>
          </div>
        </div>
        <div class="nodata" *ngIf="newsList?.length == 0">
          <i class="fa fa-exclamation-triangle icon"></i>
          <p>No Data Available</p>
        </div>
      </div>
    </div>
</div>

<ng-template #AddTicker>
    <app-shared-ticker-add [userId]="sellerId" (closeModal)="closeAddTickerModal($event)" [modalRef]="modalRefAddTicker"></app-shared-ticker-add>
</ng-template>
